export enum Agent {
  Chatbot = 'chatbot',
  ResearchSpecialist = 'research-specialist',
  Sitetracker = 'sitetracker',
  Meetings = 'meetings',
  Knowledge = 'knowledge',
  CommunityKnowledge = 'community_knowledge',
  InternalSitetracker = 'internal-sitetracker',
  InternalSupervisor = 'internal-supervisor',
  Classification = 'classification',
  Sthr = 'sthr',
}

export const EXTERNAL_AGENTS = [Agent.Sitetracker];

export enum Model {
  ClaudeOpus420250514 = 'claude-opus-4-20250514',
  ClaudeOpus4120250805 = 'claude-opus-4-1-20250805',
  ClaudeSonnet420250514 = 'claude-sonnet-4-20250514',
  ClaudeSonnet4520250929 = 'claude-sonnet-4-5-20250929',
  ClaudeHaiku4520251001 = 'claude-haiku-4-5-20251001',
  Claude37Sonnet20250219 = 'claude-3-7-sonnet-20250219',
  Claude37SonnetLatest = 'claude-3-7-sonnet-latest',
  Claude35Haiku20241022 = 'claude-3-5-haiku-20241022',
  Claude35HaikuLatest = 'claude-3-5-haiku-latest',
  Claude35Sonnet20240620 = 'claude-3-5-sonnet-20240620',
  Claude35Sonnet20241022 = 'claude-3-5-sonnet-20241022',
  Claude35SonnetLatest = 'claude-3-5-sonnet-latest',
  Gpt5 = 'gpt-5',
  Gpt4o = 'gpt-4o',
  Gpt4oMini = 'gpt-4o-mini',
  Gpt4Turbo = 'gpt-4-turbo',
  Gpt4TurboPreview = 'gpt-4-turbo-preview',
  Gpt4 = 'gpt-4',
  Gpt35Turbo = 'gpt-3.5-turbo',
  O1Preview = 'o1-preview',
  O1Mini = 'o1-mini',
  Gemini25Pro = 'gemini-2.5-pro',
  Gemini25Flash = 'gemini-2.5-flash',
  Gemini20Flash = 'gemini-2.0-flash',
  Gemini15Pro = 'gemini-1.5-pro',
  Gemini15Flash = 'gemini-1.5-flash',
  Gemini15ProLatest = 'gemini-1.5-pro-latest',
  Gemini15FlashLatest = 'gemini-1.5-flash-latest',
}

export const EXTERNAL_MODELS = [
  Model.ClaudeOpus420250514,
  Model.ClaudeOpus4120250805,
  Model.ClaudeSonnet4520250929,
  Model.ClaudeSonnet420250514,
  Model.Claude37Sonnet20250219,
  Model.Claude37SonnetLatest,
  Model.Claude35Sonnet20240620,
  Model.Claude35Sonnet20241022,
  Model.Claude35SonnetLatest,
  Model.ClaudeHaiku4520251001,
  Model.Claude35Haiku20241022,
  Model.Claude35HaikuLatest,
];

export const DEFAULT_MODEL = Model.ClaudeHaiku4520251001;
export const DEFAULT_AGENT = Agent.Sitetracker;

export function isValidAgent(value: string) {
  return Object.values(Agent).includes(value as Agent);
}

export function isValidModel(value: string) {
  return Object.values(Model).includes(value as Model);
}
